<script>import * as d3 from "d3";
import { tweened } from "svelte/motion";
import { cubicOut } from "svelte/easing";
export let radius;
export let arcDatum;
export let outerArc;
export let sliceArc;
export let tickArc;
export let label;
export let onLabel;
export let showLabel = true;
export let showOnLabel = true;
export let labelMargin = 0.05;
export let duration = 400;
export let easing = cubicOut;
const tweenPieArcDatum = tweened(arcDatum, {
  duration,
  easing,
  interpolate: (from, to) => {
    const interpolate = d3.interpolate(from, to);
    return (t) => interpolate(t);
  }
});
const tweenOpacity = tweened(0, {
  duration,
  easing,
  interpolate: (from, to) => {
    const interpolate = d3.interpolate(from, to);
    return (t) => interpolate(t);
  }
});
$: {
  tweenPieArcDatum.set(arcDatum);
  tweenOpacity.set(arcDatum.data.count === 0 ? 0 : 1);
}
const centerAngle = (arcDatum2) => {
  return arcDatum2 ? arcDatum2.startAngle + (arcDatum2.endAngle - arcDatum2.startAngle) / 2 : 0;
};
const labelPosition = (arcDatum2) => {
  if (tickArc) {
    const position = tickArc.centroid(arcDatum2);
    position[0] = radius * (centerAngle(arcDatum2) <= Math.PI ? 1 : -1);
    return position;
  } else {
    return [0, 0];
  }
};
const labelTextAnchor = (arcDatum2) => {
  return centerAngle(arcDatum2) <= Math.PI ? "start" : "end";
};
const labelLinePoints = (arcDatum2) => {
  if (tickArc && outerArc) {
    const position = tickArc.centroid(arcDatum2);
    position[0] = radius * (1 - labelMargin) * (centerAngle(arcDatum2) <= Math.PI ? 1 : -1);
    return [
      outerArc.centroid(arcDatum2),
      tickArc.centroid(arcDatum2),
      position
    ].toString();
  } else {
    return "";
  }
};
</script>

{#if showLabel && label && tickArc}
	{#if outerArc}
		<polyline
			points={labelLinePoints($tweenPieArcDatum)}
			style={`stroke-opacity:${$tweenOpacity};`}
			fill={'none'}
		/>
	{/if}
	<text
		dy="0.35em"
		style={`fill-opacity:${$tweenOpacity};`}
		transform={`translate(${labelPosition($tweenPieArcDatum)})`}
		text-anchor={labelTextAnchor($tweenPieArcDatum)}>{@html label(arcDatum.data)}</text
	>
{/if}
{#if showOnLabel && onLabel && sliceArc}
	<text
		class="count"
		dy="0.35em"
		style={`fill-opacity:${$tweenOpacity};`}
		transform={`translate(${sliceArc.centroid($tweenPieArcDatum)})`}
		text-anchor={'middle'}>{onLabel(arcDatum.data)}</text
	>
{/if}

<style>

</style>